import { useCallback, useRef } from 'react';
import { profile } from '../data/profile';
import { useTypewriter } from '../hooks/useTypewriter';
import { ParticleField } from '../components/ParticleField';
import { MagneticButton } from '../components/MagneticButton';
import { SocialLinks } from '../components/SocialLinks';
import { ArrowRightIcon, DownloadIcon } from '../components/icons';
import './Hero.css';

export function Hero({ onNavigate }) {
  const glowRef = useRef(null);
  const role = useTypewriter(profile.roles);

  const onMouseMove = useCallback((e) => {
    if (glowRef.current) {
      glowRef.current.style.left = `${e.clientX - 300}px`;
      glowRef.current.style.top = `${e.clientY - 300}px`;
    }
  }, []);

  return (
    <section id="hero" className="hero" onMouseMove={onMouseMove}>
      <ParticleField />
      <div className="hero-glow" ref={glowRef} aria-hidden="true" />

      <div className="hero-content">
        <p className="eyebrow hero-eyebrow">{'// Welcome to my portfolio'}</p>
        <h1 className="hero-name">{profile.name}</h1>
        <div className="hero-role">
          <span className="hero-role__text">{role}</span>
          <span className="hero-role__caret" />
        </div>
        <p className="hero-subtitle">{profile.subtitle}</p>

        <div className="hero-actions">
          <MagneticButton className="btn btn-primary" onClick={() => onNavigate('projects')}>
            View my work <ArrowRightIcon />
          </MagneticButton>
          <MagneticButton
            className="btn btn-ghost"
            href={profile.socials.resume}
            target="_blank"
            rel="noopener noreferrer"
          >
            <DownloadIcon /> Download résumé
          </MagneticButton>
        </div>

        <SocialLinks className="hero-socials" />
      </div>

      <button className="scroll-cue" onClick={() => onNavigate('about')} aria-label="Scroll to about">
        <span>Scroll</span>
        <span className="scroll-cue__arrow" />
      </button>
    </section>
  );
}
